import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/events/[...slug]/EventContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/events/[...slug]/EventsSubHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/accordion/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/admin-header/AdminHeaderBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/agenda/Agenda.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/anchored-content/AnchoredContent.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/event-dates/EventDates.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/gallery/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/gated-content/GatedBlocker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/google-map/GoogleMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BasicCountdownTimer"] */ "/workspace/src/components/grid-archive/CountdownTimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/hero/HeroRiveAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/hero/HeroSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/image-and-text/ImageAndText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/image/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LatestPostsSlider","LatestPostsGrid"] */ "/workspace/src/components/latest-posts/LatestPostsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/link-grid/LinkGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/logo-carousel/LogoCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/page-anchors/PageAnchors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/people-grid/PeopleGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookmarkAction","BookmarkButtonDefault"] */ "/workspace/src/components/post-actions/BookmarkAction.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/post-actions/DownloadBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/post-actions/PrintBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/post-actions/ShareModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/sector-slider/SectorKeenSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMPushPostMeta"] */ "/workspace/src/lib/gtm-push.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/lib/utils/parse-html-client.tsx");
